import BaseLifeCycle from './BaseLifeCycle';

class OnLoad extends BaseLifeCycle {
	constructor() {
		super(true);

		window.onload = this.onEvent;
	}
}
export default new OnLoad();
